import { useState } from 'react';
import { ResponsiveLine } from '@nivo/line'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExpand } from '@fortawesome/free-solid-svg-icons';
import { CloseIcon } from '../../../Common/SvgIcons/WorkflowIcons';
import NivoTextParser from './NivoTextParser';
import nivoTheme from './nivoTheme';

const lineChartTheme = {
    ...nivoTheme,
    crosshair: {
        line: {
            stroke: 'var(--text-color)',
            strokeWidth: 1.5,
            strokeDasharray: '4 4',
            opacity: 0.75,
        },
    },
};

// make sure parent container have a defined height when using
// responsive component, otherwise height will be 0 and
// no chart will be rendered.
// website examples showcase many properties,
// you'll often use just a few of them.
export const LineChart = ({ data, xlabel, ylabel, title }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isHovered, setIsHovered] = useState(false);
    const normalizedData = Array.isArray(data) ? data : [];

    const idToColorMap = {};

    // Dynamically create the color map from data
    normalizedData.forEach(item => {
        idToColorMap[item.id] = item[`${item.id} Color`];
    });

    const colors = normalizedData.map(entry => idToColorMap[entry.id]);

    const renderChart = () => (
        <ResponsiveLine
            data={normalizedData}
            margin={{ top: 50, right: 110, bottom: 50, left: 60 }}
            xScale={{ type: 'linear' }}
            yScale={{
                type: 'linear',
                min: 0,
                max: 'auto',
                stacked: false,
                reverse: false
            }}
            yFormat=" >-.2f"
            axisTop={null}
            axisRight={null}
            axisBottom={{
                tickSize: 5,
                tickPadding: 5,
                tickRotation: 0,
                legend: xlabel,
                legendOffset: 36,
                legendPosition: 'middle',
                truncateTickAt: 0
            }}
            axisLeft={{
                tickSize: 5,
                tickPadding: 5,
                tickRotation: 0,
                legend: ylabel,
                legendOffset: -40,
                legendPosition: 'middle',
                truncateTickAt: 0
            }}
            theme={lineChartTheme}
            pointSize={10}
            pointColor={{ theme: 'background' }}
            pointBorderWidth={2}
            pointBorderColor={{ from: 'serieColor' }}
            pointLabelYOffset={-12}
            useMesh={true}
            enableCrosshair={true}
            colors={colors}
            legends={[
                {
                    anchor: 'bottom-right',
                    direction: 'column',
                    justify: false,
                    translateX: 100,
                    translateY: 0,
                    itemsSpacing: 0,
                    itemDirection: 'left-to-right',
                    itemWidth: 80,
                    itemHeight: 20,
                    itemOpacity: 0.75,
                    symbolSize: 12,
                    symbolShape: 'circle',
                    symbolBorderColor: 'rgba(0, 0, 0, .5)',
                    effects: [
                        {
                            on: 'hover',
                            style: {
                                itemBackground: 'rgba(0, 0, 0, .03)',
                                itemOpacity: 1
                            }
                        }
                    ]
                }
            ]}
        />
    );

    return (
        <>
            <div
                className='chart'
                style={{ height: "400px", position: "relative" }}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
            >
                {isHovered && (
                    <div
                        style={{
                            position: 'absolute',
                            top: 10,
                            right: 10,
                            cursor: 'pointer',
                            zIndex: 2,
                        }}
                        onClick={(e) => {
                            e.stopPropagation();
                            setIsModalOpen(true);
                        }}
                    >
                        <FontAwesomeIcon icon={faExpand} title='Expand' />
                    </div>
                )}

                {renderChart()}
            </div>

            {isModalOpen && (
                <div
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100vh',
                        backgroundColor: 'rgba(0, 0, 0, 0.7)',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        zIndex: 6,
                    }}
                    onClick={() => setIsModalOpen(false)}
                >
                    <div
                        className='pt-0 pe-0 container-card w-75 w-md-100'
                        style={{
                            backgroundColor: 'var(--bg-color8)',
                            padding: '50px',
                            height: '70%',
                            position: 'relative',
                            overflow: 'visible',
                        }}
                        onClick={(e) => e.stopPropagation()}
                    >
                        <button
                            type="button"
                            aria-label="Close expanded chart"
                            className='plain-button text-danger'
                            onClick={(e) => {
                                e.stopPropagation();
                                setIsModalOpen(false);
                            }}
                            style={{
                                position: 'absolute',
                                top: 10,
                                right: 10,
                                cursor: 'pointer',
                                zIndex: 3,
                            }}
                        >
                            <CloseIcon className='wf-icon text-secondary' />
                        </button>

                        <div
                            className='p-3'
                            style={{
                                width: '100%',
                                height: '100%',
                            }}
                        >
                            {title && (
                                <div className='d-j-a' style={{ height: '50px' }}>
                                    {/* <NivoTextParser title={title} /> */}
                                    <h6>{title}</h6>
                                </div>
                            )}
                            <div style={{ height: title ? 'calc(100% - 50px)' : '100%' }}>
                                {renderChart()}
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    )
}
